import React, { useEffect, useState } from 'react';

/* MUI */
import { TextField, Typography, useTheme } from '@mui/material';
import { InputProps as StandardInputProps } from '@mui/material/Input/Input';

/* TYPES */
import {
  EnumScheduleType,
  ThermostatPendingSchedule,
  ThermostatScheduleTemplate,
  ThermostatScheduleTemplateValue,
} from '../../../../../types/generated-types';
import { FormValues } from '../../types/scheduleDetailFormValues';

/* FORMIK */
import { useFormik } from 'formik';

/* COMPONENTS */
import BorderedSection from '../../../shared/borderedSection';
import { SetpointLimitSettings } from '../../types/setpointLimitSettings';
import { ScheduleDetailEditor } from './schedule-detail-editor';
import {
  allDaysEqual,
  weekdaysEqual,
  weekendsEqual,
} from '../helpers/checkScheduleType';

interface ScheduleDetailFormProps {
  template: Partial<ThermostatScheduleTemplate> | null;
  formik: ReturnType<typeof useFormik<FormValues>>;
  scheduleType: EnumScheduleType;
  scheduleValues: ThermostatScheduleTemplateValue | ThermostatPendingSchedule;
  onChange: StandardInputProps['onChange'];
  setScheduleValues: (
    schedule: ThermostatScheduleTemplateValue | ThermostatPendingSchedule,
  ) => void;
  scheduleTemplateSetpointProfileSettings?: SetpointLimitSettings;
}

export function ScheduleTemplateDetailForm(props: ScheduleDetailFormProps) {
  const {
    template,
    setScheduleValues,
    scheduleValues,
    scheduleType,
    scheduleTemplateSetpointProfileSettings,
  } = props;

  const [selectedScheduleType, setSelectedScheduleType] =
    useState<EnumScheduleType>(EnumScheduleType.SameEveryDay);

  const theme = useTheme();

  useEffect(() => {
    if (scheduleType) {
      setSelectedScheduleType(scheduleType);
    }
  }, [scheduleType]);

  return (
    <div style={{ width: '100%' }}>
      <TextField
        fullWidth
        required
        autoFocus
        id="name"
        name="name"
        placeholder="Template Name"
        label="Template Name"
        value={props.formik.values.name}
        onChange={props.onChange}
      />
      <br />
      <br />
      <BorderedSection title="Details">
        <Typography>
          Property Default:{' '}
          {template?.isPropertyDefault ? (
            <span style={{ color: theme.embue.bad }}>Yes</span>
          ) : (
            <span style={{ color: theme.embue.off }}>No</span>
          )}
        </Typography>
        <Typography>
          Assigned Unit Count:{' '}
          <span style={{ color: theme.embue.bad }}>
            {template?.assignedUnitCount ?? ''}
          </span>
        </Typography>
      </BorderedSection>
      <br />
      <ScheduleDetailEditor
        scheduleValues={scheduleValues}
        scheduleType={selectedScheduleType}
        setScheduleType={setSelectedScheduleType}
        setScheduleValues={setScheduleValues}
        setpointLimitSettings={scheduleTemplateSetpointProfileSettings}
      />
    </div>
  );
}
